import { useCallback, useEffect, useState } from 'react'

export const usePeerService = (peerService: any) => {
  const [peers, setPeers] = useState<any[]>([])
  const [bots, setBots] = useState<any[]>([])

  const refresh = useCallback(
    async (opts?: any) => {
      if (!peerService) return
      const result = await peerService.discover(opts)
      setPeers(result.peers)
      setBots(result.bots)
    },
    [peerService],
  )

  useEffect(() => {
    if (!peerService) return
    refresh()
    const interval = setInterval(() => refresh(), 30000)
    return () => clearInterval(interval)
  }, [peerService, refresh])

  return { peers, bots, refresh }
}
